export const errorMsg = {
	logoutMsg : "You session has expired, Please login again!"
};
